export default __webpack_public_path__ + "static/15-6a89841cf51e68fdf0d054866565d934.jpg";